// extracted by mini-css-extract-plugin
export default {"errorBlock":"ErrorFallback_errorBlock__FOjPf","errorWrapper":"ErrorFallback_errorWrapper__GWl1t"};